import React from 'react';
import classNames from 'classnames';
import type { MaintenanceRequestStatus } from '../../core/Types';
import statusStyles from '../../stylesheets/maintenance/statusPill.module.scss';

interface StatusPillProps {
  status: MaintenanceRequestStatus;
}

const STATUS_LABELS: Record<MaintenanceRequestStatus, string> = {
  new: 'New',
  open: 'Open',
  inProgress: 'In Progress',
  completed: 'Completed',
};

const StatusPill = ({ status }: StatusPillProps) => {
  const statusClass = {
    new: statusStyles.statusNew,
    open: statusStyles.statusOpen,
    inProgress: statusStyles.statusInProgress,
    completed: statusStyles.statusCompleted,
  }[status];

  return (
    <span className={classNames(statusStyles.statusPill, statusClass)}>
      {STATUS_LABELS[status]}
    </span>
  );
};

export default StatusPill;
